import { cn } from "@izicvs/utils";
import { Trans } from "@lingui/macro";

type Props = {
  className?: string;
};

export const Copyright = ({ className }: Props) => (
  <div
    className={cn(
      "prose prose-sm prose-zinc flex max-w-none flex-col gap-y-1 text-xs opacity-40 dark:prose-invert",
      className,
    )}
  >
    <span>
      <Trans>
        © 2025{" "}
        <a href="https://nextilabs.com" target="_blank" rel="noreferrer">
          Nextilabs
        </a>
      </Trans>
    </span>
    <span>
      <Trans>Your career, powered by AI.</Trans>
    </span>
    <span className="mt-4">
      <Trans>Izicvs v{appVersion}</Trans>
    </span>
  </div>
);
